import React from "react";
import classes from "./PopupComponent.module.scss";
import { useTheme } from "../../utils/ThemeContext";
import { resetDrawsForGame } from "../../store/gameSlice";
import { useDispatch } from "react-redux";
import { GiPartyPopper } from 'react-icons/gi';
import { GiBrokenHeart } from 'react-icons/gi';



function PopupComponent({ onClose, popUpstatus, draws, resultPick3, resultLotto_5_90, resultLotto_4_48, resultLotto_6_49, paddingCont }) {
    const { theme } = useTheme();
    const dispatch = useDispatch();


    let resultNumbers = [];
    if (theme.themeName === "lotto 5/90") {
        resultNumbers = resultLotto_5_90;
    } else if (theme.themeName === "lotto 4/48") {
        resultNumbers = resultLotto_4_48;
    } else if (theme.themeName === "Lotto 6/49") {
        resultNumbers = resultLotto_6_49;
    } else if (theme.themeName === "pick 3") {
        resultNumbers = resultPick3;
    }

    const drawnNumbers = Array.isArray(draws) && draws.length > 0 ? draws[draws.length - 1].numbers : [];
    const matchedNumbers = drawnNumbers.filter(num => resultNumbers.includes(num));



    const instructions = [
        `Click on ${theme.themeName}.`,
        `Pick ${theme.pickedNumbers} numbers ranging from ${theme.howtoPlay}.`,
        "Or click choose random, and the system will automatically and randomly generate numbers for you.",
        `${theme.themeName} draws take place every ${theme.counterTime} minutes.`
    ];

    const onClosehandler = () => {
        dispatch(resetDrawsForGame(theme.themeName));
        onClose();
    }




    return (
        <div className={`${classes.HowToPlayCont} ${classes[paddingCont]}`} >
            <div className={classes.exitIcon} onClick={popUpstatus ? onClosehandler : onClose} style={{ color: theme.textColor }}>x</div>
            {popUpstatus && drawnNumbers.length > 0 && resultNumbers.length > 0 ? (
                <>
                    <span className={classes.titleStyleStatus} style={{ color: theme.textColor }}>Game Results for {theme.themeName}</span>


                    <div className={classes.allInfo}>
                        <div className={classes.resultMessage}>
                            {matchedNumbers.length > 0 ? (
                                <>
                                    <GiPartyPopper size={100} color="gold" className={classes.iconWin} />
                                    <div className={classes.textMessageSucces} style={{ color: theme.textColor }}>
                                        Congrats! You matched {matchedNumbers.length} number:
                                        <div className={classes.matchedNumbersContainer}>
                                            {matchedNumbers.map((num, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className={classes.circle}
                                                        style={{ backgroundColor: "gold", color: "black" }}
                                                    >
                                                        <span className={classes.numberBall}>{num}</span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <GiBrokenHeart size={100} color="gold" className={classes.iconWin} />
                                    <div className={classes.textMessageSucces} style={{ color: theme.textColor }}>
                                        No matches. Try again!
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    <div className={classes.btnCenteredStyle}>
                        <button
                            className={`${classes.bettingBtn} ${classes.btnFirstStyle}`}
                            style={{ '--hover-color': theme.hoverColor, boxShadow: theme.boxShadow }}
                            onClick={onClosehandler}
                        >
                            Re-Bet
                        </button>
                    </div>
                </>
            ) : (
                <>
                    {instructions.map((text, index) => (
                        <div key={index} className={classes.objectInfo}>
                            <div className={classes.circleNumber} style={{ background: theme.textColor }}>
                                <span className={classes.numberInside}>{index + 1}</span>
                            </div>
                            <span className={classes.subTitlesStyle} style={{ color: theme.textColor }}>{text}</span>
                        </div>
                    ))}
                </>
            )}
        </div>
    );

}

export default PopupComponent;
